/**
 * components/ChunkErrorBoundary.js — Апп бүхэлдээ унахаас сэргийлэх хамгаалалт.
 *
 * ЯАГААД:
 *   React-д ямар нэг компонент render хийх үедээ алдаа шидвэл, барих
 *   ErrorBoundary БАЙХГҮЙ бол React БҮХ модыг unmount хийдэг — үр дүнд нь
 *   бүрэн ЦАГААН ХУУДАС үлдэнэ. Хэрэглэгчид ямар ч мэдэгдэл харагдахгүй,
 *   зөвхөн console-д алдаа бичигдэнэ.
 *
 *   Code splitting-ийн дараа энэ нь онолын биш, БОДИТ эрсдэл болсон:
 *   chunk олдохгүй бол `React.lazy` throw хийнэ (дэлгэрэнгүйг
 *   `utils/lazyRetry.js`-ээс уншина уу).
 *
 * ЗАН ТӨЛӨВ:
 *   • Chunk алдаа  → сессэд нэг удаа автоматаар reload. Тус болоогүй бол
 *                    «Шинэчлэх» товчтой ойлгомжтой мэдэгдэл.
 *   • Бусад алдаа  → reload ХИЙХГҮЙ (bug-д тус болохгүй, зөвхөн хэрэглэгчийн
 *                    оруулсан мэдээллийг устгана). Мэдэгдэл + буцах товч.
 *
 * ⚠ ErrorBoundary нь render/lifecycle-ийн алдааг л барина. Event handler ба
 *   async кодын алдааг барихгүй — тэдгээрийг try/catch-аар шийднэ.
 */

import React from "react";
import { isChunkError, reloadOnce } from "src/utils/lazyRetry";

const wrap = {
  minHeight: "60vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
};
const card = {
  maxWidth: 460,
  width: "100%",
  textAlign: "center",
  background: "#fff",
  border: "1px solid #E8EBF0",
  borderRadius: 12,
  padding: "32px 28px",
  boxShadow: "0 4px 20px rgba(16,24,40,0.06)",
};
const btn = {
  marginTop: 18,
  padding: "10px 22px",
  border: "none",
  borderRadius: 8,
  background: "#1B7A45",
  color: "#fff",
  fontWeight: 700,
  fontSize: 14,
  cursor: "pointer",
};

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, chunk: false };
  }

  static getDerivedStateFromError(error) {
    return { error, chunk: isChunkError(error) };
  }

  componentDidCatch(error, info) {
    // Хөгжүүлэгчид мөрдөх ул мөр үлдээнэ — production-д ч console-д харагдана.
    // eslint-disable-next-line no-console
    console.error("[ChunkErrorBoundary]", error, info?.componentStack);

    // Chunk алдаа бол нэг удаа өөрөө сэргэхийг оролдоно. `lazyRetry` дотор
    // аль хэдийн оролдсон байж болох тул `reloadOnce` false буцааж магадгүй —
    // тэр тохиолдолд доорх дэлгэц харагдана.
    if (isChunkError(error)) reloadOnce();
  }

  render() {
    const { error, chunk } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={wrap}>
        <div style={card}>
          <i
            className={
              chunk
                ? "fas fa-cloud-download-alt"
                : "fas fa-exclamation-triangle"
            }
            style={{ fontSize: 40, color: chunk ? "#0EA5E9" : "#E2382E" }}
          />
          <h3 style={{ marginTop: 16, fontWeight: 800, fontSize: 18 }}>
            {chunk ? "Шинэ хувилбар гарсан байна" : "Алдаа гарлаа"}
          </h3>
          <p style={{ color: "#667085", fontSize: 14, marginTop: 8 }}>
            {chunk
              ? "Системийн шинэчлэл хийгдсэн тул хуудсыг дахин ачаалах шаардлагатай."
              : "Хуудсыг харуулах явцад саатал гарлаа. Дахин оролдоно уу."}
          </p>
          <button
            type="button"
            style={btn}
            onClick={() => window.location.reload()}
          >
            Хуудсыг шинэчлэх
          </button>
          {!chunk && (
            <div style={{ marginTop: 12 }}>
              <button
                type="button"
                style={{
                  ...btn,
                  marginTop: 0,
                  background: "transparent",
                  color: "#667085",
                  fontWeight: 600,
                }}
                onClick={() => window.location.assign("/me")}
              >
                Нүүр хуудас руу
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
